module.exports = __webpack_public_path__ + "static/media/beata-candelaria-san-jose.31ccb21b.JPG";